import { render, staticRenderFns } from "./PcHeader.vue?vue&type=template&id=068bfa0e&scoped=true&"
import script from "./PcHeader.vue?vue&type=script&lang=js&"
export * from "./PcHeader.vue?vue&type=script&lang=js&"
import style0 from "./PcHeader.vue?vue&type=style&index=0&id=068bfa0e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068bfa0e",
  null
  
)

export default component.exports